import { CommonModule } from '@angular/common';
import { Component, computed, inject, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { PRIME_MISC_MODULES } from '../../prime-ng/prime-misc.imports';
import { IMenuItem } from '../../interfaces/menuItems.interface';
import { AuthStore } from 'src/app/core/store/auth.store';
import { MODULE_IDS } from 'src/app/core/constants/modules.constants';

@Component({
  selector: 'shared-sidebar',
  imports: [
    ...PRIME_MISC_MODULES,
    CommonModule,
    RouterModule],
  templateUrl: 'sidebar.component.html',
  styleUrl: 'sidebar.component.css'
})

export class SidebarComponent implements OnInit {

  private store = inject(AuthStore);
  private router = inject(Router);
  public isVisible: boolean = false;

  public menuItems = computed(() => {
    const accessIds = this.store.accessIds();
    const menuData = this.store.menuData();


    if (!menuData) {
      return [];
    }

    const result = menuData
      .map(category => {
        // Normalizar icono de categoría: si viene sin 'pi-', agregarlo
        let categoryIcon = category.icon || 'pi-folder';
        if (!categoryIcon.startsWith('pi pi-') && !categoryIcon.startsWith('pi-')) {
          categoryIcon = `pi-${categoryIcon}`;
        }

        const filteredChildren = category.children
          .filter(child => {
            // Debe tener un path válido y el usuario debe tener acceso al módulo (key)
            const hasPath = child.path !== null;
            const hasAccess = accessIds.includes(child.key);
            return hasPath && hasAccess;
          })
          .map(child => ({
            label: child.label,
            route: child.path!,
            module: child.key
          }));

        return {
          label: category.label,
          icon: categoryIcon,
          items: filteredChildren
        };
      })
      .filter(category => {
        const hasItems = category.items.length > 0;
        return hasItems;
      });

    return result;
  });

  constructor() { }

  ngOnInit() { }

  toggleSidebar(): void {
    this.isVisible = !this.isVisible;
  }
  closeSidebar(): void {
    this.isVisible = false;
  }

  public navigateTo(route: string): void {
    this.router.navigate([route]);
    this.closeSidebar();
  }
}

